import React, {FC, ReactElement, useMemo} from 'react';
import {Case, CaseProps} from './Case';

interface ComponentSwitchProps {
	value: any;
	children: ReactElement<CaseProps> | ReactElement<CaseProps>[];
}

interface SwitchSubmodules {
	Case: typeof Case;
}

export const ComponentSwitch: FC<ComponentSwitchProps> & SwitchSubmodules = ({value, children}) => {
	const elements = useMemo(() => {
		return React.Children.map(children, (child) => {
			if (React.isValidElement(child)) return React.cloneElement(child, {value} as any);
			else return null;
		});
	}, [value, children]);

	return <>{elements}</>;
};

ComponentSwitch.Case = Case;
